import * as React from 'react'

import { connect } from 'react-redux'

import { communicationToLoadableProps } from '../../project-utils'
import {
  ApplicationState,
  educationEditRequest,
  educationGetRequest,
  selectEducation,
}                                       from '../../redux'
import { ExperienceType }               from '../../types'
import { EducationEditForm }            from '../forms'

const mstp = (state: ApplicationState) =>
  ({
    educationGetCommunication:  educationGetRequest.communicationSelector(state),
    educationEditCommunication: educationEditRequest.communicationSelector(state),
    education:                  selectEducation(state),
  })

const actions = {
  getEducation:  educationGetRequest.actionCreator,
  editEducation: educationEditRequest.actionCreator,
}

interface EditPersonalInformationProps {
  experienceType: ExperienceType
}

type Props =
  EditPersonalInformationProps
  & ReturnType<typeof mstp>
  & typeof actions

class EditPersonalInformation extends React.Component<Props> {
  public componentDidMount () {
    this.props.getEducation()
  }

  public render () {
    const {
      educationGetCommunication,
      educationEditCommunication,
      education,
    } = this.props

    return (
      <EducationEditForm
        key={education && education.length}
        isCached={education instanceof Array}
        onSubmit={this.handleSubmit}
        values={{ education }}
        {...communicationToLoadableProps(educationGetCommunication)}
        {...educationEditCommunication}
      />
    )
  }

  private handleSubmit = values => {
    const { editEducation, experienceType } = this.props

    editEducation(experienceType, values)
  }
}

export default connect(
  mstp,
  actions,
)(EditPersonalInformation)



// WEBPACK FOOTER //
// ./src/components/environments/EditEducation.tsx